//@ts-nocheck
import axios from "axios";
import store from "../redux/store";


const createInstance = (()=>{
  const instance =  axios.create({
    // baseURL:store.getState().ui.config.connectorUrl,
  });
  
  instance.interceptors.request.use(function (config) {
    let { user } = store.getState()
    let token = user?.data?.customerToken
    if(token){
      config.headers = {
        'Authorization': `Bearer ${token}`,
      }
      return config;
    }
  return config;
  }, function (error) {
  // Do something with request error
  return Promise.reject(error);
  });

  return instance
})()

export default createInstance;
